import BEnergy from "./BEnergy";

export default class BQuantity
{
	constructor(amount, unit)
	{
		this.amount = amount;
		this.unit = unit;
	}

	getAmount()
	{
		return this.amount;
	}

	getUnit()
	{
		return this.unit;
	}

	getReadablePrecision()
	{
		switch (this.getUnit().toUpperCase()) {
			case "J":
			case "KJ":
			case "CAL":
			case "KCAL":
				return 0;
				break;
			default:
				return 1;
				break;
		}
	}

	getReadableQuantity()
	{
		switch (this.getUnit().toUpperCase()) {
			case "J":
			case "KJ":
				return new BEnergy(this.getAmount(), this.getUnit()).getQuantity("kJ");
				break;
			case "CAL":
			case "KCAL":
				return new BEnergy(this.getAmount(), this.getUnit()).getQuantity("kcal");
				break;
			default:
				return new BQuantity(this.getAmount(), this.getUnit());
				break;
		}
	}

	getReadableAmount()
	{
		return `${parseFloat(this.getReadableQuantity().getAmount().toFixed(this.getReadablePrecision())).toLocaleString("cs")}`;
	}

	getFormAmount()
	{
		return this.getReadableAmount().replace(/\s+/g, "");
	}

	getReadable()
	{
		return `${this.getReadableAmount()} ${this.getReadableQuantity().getUnit()}`;
	}
}
